// Copyright (c) 2005-2019, Coveo Solutions Inc.
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var coveo_search_ui_1 = require("coveo-search-ui");
var EndpointCaller_1 = require("../Base/EndpointCaller");
var GOOGLE_PROVIDER_VALUE = "google";
var SITECORE_PROVIDER_VALUE = "sitecoreGeolocation";
var BROWSER_PROVIDER_VALUE = "browser";
var CUSTOM_PROVIDER_VALUE = "custom";
var GOOGLE_MAP_BASE_URL = "https://www.googleapis.com/geolocation/v1/geolocate?key=";
var CoveoForSitecoreDistanceResources = (function (_super) {
    __extends(CoveoForSitecoreDistanceResources, _super);
    /** Initialize the distance resources component that queries distance */
    function CoveoForSitecoreDistanceResources(element, options, bindings) {
        _super.call(this, element, CoveoForSitecoreDistanceResources.ID, bindings);
        this.element = element;
        this.options = options;
        this.bindings = bindings;
        this.providerWarningDisabled = false;
        this.options = coveo_search_ui_1.ComponentOptions.initComponentOptions(element, CoveoForSitecoreDistanceResources, options);
        this.endpointCaller = new EndpointCaller_1["default"]();
        if (this.options.geolocationProviders) {
            this.options.geolocationProviders = this.options.geolocationProviders.reverse();
            this.tryNextGeolocationProvider();
        }
    }
    CoveoForSitecoreDistanceResources.prototype.setDistance = function (latitude, longitude) {
        this.latitude = latitude;
        this.longitude = longitude;
        this.registerDistanceQuery();
        this.queryController.executeQuery();
    };
    CoveoForSitecoreDistanceResources.prototype.setCoordinateFromGoogle = function () {
        var _this = this;
        if (!!this.options.googleApiKey) {
            var postData = {};
            var baseMapsUrl = GOOGLE_MAP_BASE_URL + this.options.googleApiKey;
            var geolocationResponse = this.endpointCaller.sendPost(baseMapsUrl, postData);
            geolocationResponse.then(function (positionData) {
                var location = positionData.data.location;
                if (!!location) {
                    _this.setDistance(location.lat, location.lng);
                }
                else {
                    _this.tryNextGeolocationProvider();
                }
            });
        }
        else {
            this.logger.error(GOOGLE_PROVIDER_VALUE + " provider was selected, but \"googleApiKey\" option was not set.");
            this.tryNextGeolocationProvider();
        }
    };
    CoveoForSitecoreDistanceResources.prototype.setDefaultCoordinates = function () {
        if (!this.isNullOrEmpty(this.options.defaultLatitude) && !this.isNullOrEmpty(this.options.defaultLongitude)) {
            this.setDistance(this.options.defaultLatitude, this.options.defaultLongitude);
        }
        else {
            this.logger.error(SITECORE_PROVIDER_VALUE + " provider was selected, but \"defaultLongitude\" and \"defaultLatitude\" options were not set.");
            this.tryNextGeolocationProvider();
        }
    };
    CoveoForSitecoreDistanceResources.prototype.setCoordinatesFromBrowser = function () {
        var _this = this;
        navigator.geolocation.getCurrentPosition(function (position) {
            _this.setDistance(position.coords.latitude, position.coords.longitude);
        }, function (err) {
            _this.tryNextGeolocationProvider();
        });
    };
    CoveoForSitecoreDistanceResources.prototype.registerDistanceQuery = function () {
        var _this = this;
        this.bind.onRootElement(Coveo.QueryEvents.buildingQuery, function (args) {
            var geoQueryFunction = {
                'function': _this.getConvertedUnitsFunction("dist(" + _this.options.latitudeField + ", " + _this.options.longitudeField + ", " + _this.latitude + ", " + _this.longitude + ")"),
                'fieldName': _this.options.distanceField
            };
            if (args && args.queryBuilder) {
                args.queryBuilder.queryFunctions.push(geoQueryFunction);
                _this.enableDistanceComponents();
            }
        });
    };
    CoveoForSitecoreDistanceResources.prototype.enableDistanceComponents = function () {
        var _this = this;
        // Don't iterate directly on "distanceComponents", since we remove the class, the element also gets removed from the iterator in the "for-loop".
        var distanceComponents = document.getElementsByClassName(this.options.disabledDistanceCssClass);
        var elements = [];
        for (var i = 0, length_1 = distanceComponents.length; i < length_1; i++) {
            elements.push(distanceComponents.item(i));
        }
        elements.forEach(function (element) {
            try {
                element.classList.remove(_this.options.disabledDistanceCssClass);
                Coveo.get(element).enable();
            }
            catch (exception) {
                _this.logger.error("Could not re-enable distance component:", exception, element);
            }
        });
    };
    CoveoForSitecoreDistanceResources.prototype.getConvertedUnitsFunction = function (queryFunction) {
        return queryFunction + "/" + this.options.unitConversionFactor;
    };
    CoveoForSitecoreDistanceResources.prototype.tryNextGeolocationProvider = function () {
        var currentGeolocationProvider = this.options.geolocationProviders.pop();
        if (currentGeolocationProvider == null) {
            if (!this.providerWarningDisabled) {
                console.warn("None of the mentioned geolocation providers were able to provide the user's coordinates. The distance field will not be calculated and the distance components will be disabled until the next call to \"setDistance\".");
            }
        }
        else {
            switch (currentGeolocationProvider) {
                case GOOGLE_PROVIDER_VALUE:
                    this.setCoordinateFromGoogle();
                    break;
                case CUSTOM_PROVIDER_VALUE:
                    this.providerWarningDisabled = true;
                    break;
                case SITECORE_PROVIDER_VALUE:
                    this.setDefaultCoordinates();
                    break;
                case BROWSER_PROVIDER_VALUE:
                    this.setCoordinatesFromBrowser();
                    break;
                default:
                    console.warn("Invalid geolocation provider: '" + currentGeolocationProvider + "'.");
                    this.tryNextGeolocationProvider();
            }
        }
    };
    CoveoForSitecoreDistanceResources.prototype.isNullOrEmpty = function (value) {
        return value === null || typeof (value) === "undefined";
    };
    CoveoForSitecoreDistanceResources.ID = "ForSitecoreDistanceResources";
    CoveoForSitecoreDistanceResources.options = {
        distanceField: coveo_search_ui_1.ComponentOptions.buildStringOption(),
        latitudeField: coveo_search_ui_1.ComponentOptions.buildStringOption(),
        longitudeField: coveo_search_ui_1.ComponentOptions.buildStringOption(),
        defaultLatitude: coveo_search_ui_1.ComponentOptions.buildNumberOption(),
        defaultLongitude: coveo_search_ui_1.ComponentOptions.buildNumberOption(),
        geolocationProviders: coveo_search_ui_1.ComponentOptions.buildListOption(),
        googleApiKey: coveo_search_ui_1.ComponentOptions.buildStringOption(),
        unitType: coveo_search_ui_1.ComponentOptions.buildStringOption(),
        unitConversionFactor: coveo_search_ui_1.ComponentOptions.buildStringOption(),
        disabledDistanceCssClass: coveo_search_ui_1.ComponentOptions.buildStringOption({
            defaultValue: "coveo-distance-disabled"
        })
    };
    return CoveoForSitecoreDistanceResources;
}(coveo_search_ui_1.Component));
exports.CoveoForSitecoreDistanceResources = CoveoForSitecoreDistanceResources;
coveo_search_ui_1.Initialization.registerAutoCreateComponent(CoveoForSitecoreDistanceResources);



//////////////////
// WEBPACK FOOTER
// ./CoveoDistanceRessources/CoveoDistanceResources.ts
// module id = 23
// module chunks = 0